import { memo } from "react";

export const MfaInformation = memo(() => {
	return (
		<div className="rounded-md border p-4">
			<h3 className="text-gray-900 mb-3 text-lg font-semibold">２段階認証について</h3>
			<div className="space-y-4 text-sm leading-relaxed">
				<p>
					２段階認証は、アカウントを不正利用から守るためのセキュリティ対策です。
					<br />
					パスワードだけではなくもう一つの認証を行うことで、アカウントの安全性を高められます。
				</p>
				<p>
					CHILLNNでは、パスワードに加えて「メールで送られる認証コード」を入力する方式を採用しています。
					<br />
					これにより万が一パスワードが流出しても、メールを受信することができなければ第三者はログインできません。
					<br />
					大切な予約情報や顧客データを守るうえで有効な仕組みです。
				</p>
				<p>２段階認証は、全ての施設で無料でご利用いただけます。</p>

				<div className="text-xs">
					<p>※CHILLNNに導入されている２段階認証は多要素認証・2要素認証の一種です。</p>
				</div>
			</div>
		</div>
	);
});

MfaInformation.displayName = "MfaInformation";
